export const networking = {
  'QrBadge': 'Badge QR',
  'seeAll': 'Voir tout',
  'newcommers': 'New Networkers',
  'checkThemOut': 'Découvrez-les !',
  'topicsToDiscuss': 'Sujets à discuter',
  'OneOnOneMeet': 'Rencontre 1:1',
  'learnMoreNetworking': 'En savoir plus sur le Networking Hub',
  'scanQrCode': 'Scanner le code QR',
  'myBadge': 'Mon badge',
  'message': 'Message',
  'scannedBadge': 'Badge scanné',
  'viewProfile': 'Voir le profil',
  'userRatingDetails': "Détails de l'évaluation de l'utilisateur",
  'networkingHub': 'Networking Hub',
  'totalScore': 'Score total:',
  'scoreComposedOf': 'Ce score est composé de:',
  'confirmationText': 'Êtes-vous sûr ? Cela ne peut pas être annulé.',

  'welcomeMessage': 'Bienvenue sur <strong>Networking Hub</strong>, où les connexions prennent vie ! Voici comment cela fonctionne :',
  'connectingMadeSimpleTitle': 'Se connecter facilement',
  'connectingMadeSimpleDescription':
    'Le Networking Hub propose des activités et des niveaux structurés pour vous aider à vous connecter efficacement :',

  'newcomersDescription':
    '<strong>Newcomers:</strong> Explorez les profils des nouveaux arrivants, ajoutez ceux qui vous intéressent à votre liste et envoyez-leur des messages. Vous pouvez même vous connecter avec eux personnellement.',
  'shortlistDescription': "<strong>Shortlist:</strong> Dès que vous montrez de l'intérêt pour quelqu'un, il est ajouté à votre liste.",
  'contactedConnectedDescription':
    "<strong>Contacted/Connected:</strong> Lorsque vous contactez quelqu'un et recevez une réponse, cette personne passe dans ces catégories.",
  'skipDescription': '<strong>Skip:</strong> Pas intéressé ? Il vous suffit de passer au profil suivant !',

  'enhancedNetworkingActivitiesTitle': 'Activités de réseautage améliorées',
  'enhancedNetworkingActivitiesDescription': 'En plus des connexions directes, le Hub propose :',

  'topicsToDiscussDescription':
    '<strong>Topics to Discuss:</strong> Explorez les sujets qui vous intéressent et connectez-vous avec les auteurs ou les participants. Participez à des discussions en ligne ou planifiez des réunions de groupe pour approfondir ces sujets.',
  'oneOnOneMeetingPlannerDescription':
    '<strong>1:1 Meeting Planner:</strong> Gérez vos demandes de réunion, suivez les réunions prévues et organisez facilement votre emploi du temps.',

  'gamificationTitle': "Gamification pour le fun et l'engagement",
  'gamificationDescription':
    'Augmentez votre activité avec un tableau de classement qui suit vos points et met en valeur les networkers les plus actifs. Voici comment vous pouvez gagner des points :',

  'pointsSystem': {
    points1000ProfileComplete: '<strong>1 000 points:</strong> Complétez votre profil (avec une photo).',
    points1000PushNotifications: '<strong>1 000 points:</strong> Activez les notifications push.',
    points100SendMeetingRequest: '<strong>100 points:</strong> Envoyez une demande de réunion 1:1.',
    points400GetAcceptedRequest: '<strong>400 points:</strong> Faites accepter votre demande de réunion 1:1.',
    points400AcceptRequest: '<strong>400 points:</strong> Acceptez une demande de réunion 1:1.',
    points100DeclineRequest: '<strong>100 points:</strong> Refusez une demande de réunion 1:1.',
    points400CreateDiscussion: '<strong>400 points:</strong> Créez un sujet de discussion.',
    points50LikeDiscussion: '<strong>50 points:</strong> Aimez un sujet de discussion.',
    points200PostFirstComment:
      '<strong>200 points:</strong> À chaque fois que vous publiez votre premier commentaire sur un autre sujet.',
    points100LikeOnTopic: '<strong>100 points:</strong> Obtenez un "j\'aime" sur votre sujet.',
    points200UniqueCommenter: '<strong>200 points:</strong> Obtenez un commentateur unique sur votre sujet.',
    points100LikeShortlistUser: '<strong>100 points:</strong> Aimez/ajoutez un utilisateur à votre liste.',
    points50SkipUser: '<strong>50 points:</strong> Ignorez un utilisateur.',
    points200StartChat: '<strong>200 points:</strong> Démarrez une conversation (contacté).',
    points300GetChatResponse: '<strong>300 points:</strong> Recevez une réponse à une conversation (connecté).',
    points400RespondToChat: '<strong>400 points:</strong> Répondez à une demande de conversation (connecté).',
    points500SpeedNetworking: '<strong>500 points :</strong> Pour chaque session de speed networking.'
  },

  'finalMessage':
    'Tirez le meilleur parti du Networking Hub, découvrez de nouvelles opportunités et grimpez dans le classement en vous connectant et en vous engageant avec des professionnels partageant les mêmes idées !',

  'manageMeeting': 'Gérer la réunion',
  'addToCalendar': 'Ajouter au calendrier',
  'cancel': 'Annuler',
  'accept': 'Accepter',
  'accept&addToCalendar': 'Accepter et ajouter au calendrier',
  'editDetails': 'Modifier les détails',
  'reject': 'Refuser',
  'delete': 'Supprimer',
  'exportContact': 'Exporter le contact',
  'scheduleNewOneOnOne': 'Planifier un nouveau tête-à-tête',
  'initiatedBy': 'Initiée par',
  'rejectedBy': 'Rejeté par',
  'you': 'vous',
  'meetPassed': 'La réunion est terminée',
  'meetInProgress': 'En cours',

  'myOneOnOne': 'Mon 1:1',

  'speed': {
    history: 'Historique',
    minutes: 'min.',
    users_available: 'utilisateurs',
    rules: 'Règles',
    activate: 'Activer',
    matching: 'Appariement...',
    start: 'Démarrer',
    find_a_user: 'Trouver un utilisateur avec la même image',
    find_a_user_number: 'Trouver un utilisateur avec le même numéro',
    waiting: 'En attente...',
    speaking_now: 'En train de parler',
    networking_topics: 'Sujets de réseautage',
    session_ended: 'Session terminée',
    find_next_partner: 'Trouver un nouveau partenaire',
    find_next_group: 'Trouver le groupe suivant',
    partner_wasnt_ready: 'Le partenaire n’était pas prêt',
    partner_wasnt_ready_description: 'Il semble que le partenaire n’était pas prêt pour la discussion. Trouvons-en un nouveau !',
    start_matching: 'Commencer l’appariement'
  }
}
